export const shortenAddress = (address: any) =>
    `${address?.slice(0, 5)}...${address?.slice(address.length - 4)}`;

    export const formatAddress = (address:any, before:any, after:any) => address && 
  `${address.substring(0, before || 4)}.....${address.substring(address.length - after || 6)}`;
